import { urls } from '../constants'
import { isAPIError, post } from '@user/store/services/crud'
import type { Activity } from '../typings'
import { toast } from '@sales-center/components'
import { createActivityActionCreator } from '../state'
import type { Actions } from '../state'

export async function createActivityEffect(
  activity: Omit<Activity, 'id'>,
): Promise<Actions | undefined> {
  const response = await post(urls.upsert, activity)

  if (!response.ok) {
    // The API error envelope is flat — { StatusCode, Message } straight from
    // ExceptionMiddleware — so there is no `payload` to read (reading one made
    // isAPIError(undefined) throw, so a failed create rejected before the toast
    // and the modal stayed stuck). The body can also be non-JSON (an HTML/empty
    // 5xx) or, on a transport failure, a plain string from the CRUD helper; none
    // of those may throw, they all fall back to the generic message.
    const error = await response.json().catch(() => undefined)
    toast.error(
      error != null && isAPIError(error)
        ? error.Message
        : 'Failed to create Activity',
    )

    return undefined
  }

  return createActivityActionCreator(await response.json())
}
